const SupportBubble = () => {
  return (
    <svg
      width="61"
      height="60"
      viewBox="0 0 61 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="30.0234" cy="30" r="30" fill="#6B97F6" />
      <path
        d="M40.3294 20.1133H19.7204C19.0491 20.1133 18.4054 20.3799 17.9307 20.8546C17.4561 21.3292 17.1895 21.973 17.1895 22.6442V34.6734C17.1895 35.0057 17.2549 35.3348 17.3821 35.6419C17.5093 35.949 17.6957 36.228 17.9307 36.463C18.1658 36.698 18.4448 36.8844 18.7518 37.0116C19.0589 37.1388 19.388 37.2043 19.7204 37.2043H31.1096C31.2055 37.2043 31.2974 37.2424 31.3652 37.3102C31.433 37.378 31.4711 37.47 31.4711 37.5658V43.6148C31.471 43.6835 31.4905 43.7509 31.5273 43.809C31.5642 43.867 31.6168 43.9134 31.679 43.9426C31.7413 43.9719 31.8106 43.9827 31.8788 43.974C31.947 43.9652 32.0113 43.9372 32.0641 43.8932L39.9172 37.2911C39.9822 37.2372 40.0641 37.2077 40.1486 37.2079H40.3294C41.0006 37.2079 41.6444 36.9412 42.119 36.4666C42.5937 35.992 42.8603 35.3482 42.8603 34.677V22.6442C42.8603 21.973 42.5937 21.3292 42.119 20.8546C41.6444 20.3799 41.0006 20.1133 40.3294 20.1133Z"
        fill="white"
      />
    </svg>
  );
};

export default SupportBubble;
